/* WideStep collection facets — chip dropdowns + REAL client-side filtering.
   Round-1 Critical fix: the previous chips only swapped their label text ("visual mock");
   nothing filtered. Now each chip carries data-ws-facet (type|tag|color|size) and each grid
   card is wrapped in .ws-fitem[data-type|tags|colors|sizes]; selecting options filters the
   rendered cards (AND across facets), updates the item count, shows a removable ✕ on active
   chips, and toggles a no-results state. Sort stays native (GET form submit). */
(function () {
  'use strict';
  var form = document.querySelector('[data-ws-facets]');
  if (!form) return;

  /* Mobile: single "Filters" trigger expands/collapses the full filter card. */
  var mobileToggle = document.querySelector('[data-ws-fbar-toggle]');
  if (mobileToggle) {
    mobileToggle.addEventListener('click', function () {
      var isOpen = form.classList.toggle('is-open');
      mobileToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }

  /* open/close chip dropdowns */
  var wraps = form.querySelectorAll('[data-ws-chip]');
  function closeAll(except) {
    wraps.forEach(function (w) {
      if (w === except) return;
      var btn = w.querySelector('.ws-chip'), menu = w.querySelector('.ws-chip-menu');
      if (btn) btn.setAttribute('aria-expanded', 'false');
      if (menu) menu.classList.remove('open');
    });
  }
  wraps.forEach(function (w) {
    var btn = w.querySelector('.ws-chip'), menu = w.querySelector('.ws-chip-menu');
    if (!btn || !menu) return;
    btn.addEventListener('click', function (e) {
      /* the ✕ inside an active chip clears that facet instead of opening the menu */
      if (e.target.closest('.ws-chip__x')) { e.preventDefault(); clearFacet(w); return; }
      e.preventDefault();
      var open = btn.getAttribute('aria-expanded') === 'true';
      closeAll(w);
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      menu.classList.toggle('open', !open);
    });
  });
  document.addEventListener('click', function (e) { if (!e.target.closest('[data-ws-chip]')) closeAll(null); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(null); });

  /* submit on change (real sort radios); price uses its Apply button */
  form.addEventListener('change', function (e) {
    if (e.target.type === 'number') return;
    form.requestSubmit ? form.requestSubmit() : form.submit();
  });

  /* ---------------- real client-side filtering ---------------- */
  var state = {}; /* facetKey ("type"/"color"/"size"/"tag:<chipname>") -> selected value */
  var items = [].slice.call(document.querySelectorAll('[data-ws-fitem]'));
  var counts = [].slice.call(document.querySelectorAll('[data-ws-count]'));
  var noRes = document.querySelector('[data-ws-noresults]');
  var promo = document.querySelector('.ws-promo');

  function facetKey(wrap) {
    var f = wrap.getAttribute('data-ws-facet');
    return f === 'tag' ? 'tag:' + wrap.getAttribute('data-ws-chipname') : f;
  }
  function listHas(attr, value) {
    return ('|' + (attr || '') + '|').indexOf('|' + value + '|') !== -1;
  }
  function matches(el) {
    for (var key in state) {
      var v = state[key];
      if (!v) continue;
      if (key === 'type') { if ((el.getAttribute('data-type') || '') !== v) return false; }
      else if (key === 'color') { if (!listHas(el.getAttribute('data-colors'), v)) return false; }
      else if (key === 'size') { if (!listHas(el.getAttribute('data-sizes'), v)) return false; }
      else { if (!listHas(el.getAttribute('data-tags'), v)) return false; } /* tag:<name> */
    }
    return true;
  }
  function apply() {
    var visible = 0;
    items.forEach(function (el) {
      var ok = matches(el);
      el.classList.toggle('is-hidden', !ok);
      if (ok) visible++;
    });
    counts.forEach(function (c) {
      var sfx = (c.getAttribute('data-count-suffix') || 'Item|Items').split('|');
      c.textContent = visible + ' ' + (visible === 1 ? sfx[0] : sfx[1]);
    });
    var anyActive = Object.keys(state).some(function (k) { return !!state[k]; });
    if (noRes) noRes.hidden = visible !== 0;
    if (promo) promo.style.display = (visible === 0) ? 'none' : '';
    /* pager filters only the RENDERED page; hide it while filters are active so
       "page 2" doesn't imply unfiltered results (single-page catalog today). */
    var pager = document.querySelector('.ws-pager');
    if (pager) pager.style.display = anyActive ? 'none' : '';
  }
  function ensureX(wrap) {
    var btn = wrap.querySelector('.ws-chip');
    if (!btn || btn.querySelector('.ws-chip__x')) return;
    var x = document.createElement('span');
    x.className = 'ws-chip__x'; x.setAttribute('aria-hidden', 'true'); x.textContent = '×';
    btn.appendChild(x);
  }
  function clearFacet(wrap) {
    var key = facetKey(wrap);
    delete state[key];
    wrap.classList.remove('is-active');
    var label = wrap.querySelector('.ws-chip__label');
    if (label) label.textContent = wrap.getAttribute('data-ws-chipname') || label.textContent;
    wrap.querySelectorAll('[data-ws-opt]').forEach(function (o) { o.classList.toggle('sel', o.getAttribute('data-value') === ''); });
    apply();
  }
  /* The no-results state renders a "Clear filters" button (data-ws-clearall) but nothing wired
     it — a shopper who filtered to zero matches was stranded (only the per-chip ✕ recovered).
     Reset every active facet at once. */
  function clearAllFacets() {
    wraps.forEach(function (w) { if (w.getAttribute('data-ws-facet')) clearFacet(w); });
    state = {};
    apply();
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-ws-clearall]')) { e.preventDefault(); clearAllFacets(); }
  });
  form.addEventListener('click', function (e) {
    var opt = e.target.closest('[data-ws-opt]');
    if (!opt) return;
    e.preventDefault();
    var wrap = opt.closest('[data-ws-chip]');
    if (!wrap || !wrap.getAttribute('data-ws-facet')) return;
    var value = opt.getAttribute('data-value') || '';
    var key = facetKey(wrap);
    wrap.querySelectorAll('[data-ws-opt]').forEach(function (o) { o.classList.remove('sel'); });
    opt.classList.add('sel');
    var label = wrap.querySelector('.ws-chip__label');
    if (label) label.textContent = opt.getAttribute('data-label') || label.textContent;
    if (value) { state[key] = value; wrap.classList.add('is-active'); ensureX(wrap); }
    else { delete state[key]; wrap.classList.remove('is-active'); }
    apply();
    closeAll(null);
  });
})();
